<script setup lang="ts">
import SidebarNav from '@/components/app/SidebarNav.vue';
import { useRouter, RouterLink } from 'vue-router'
// stores
import { useAppOptionStore } from "@/stores/app-option";
// instancias
const appOption = useAppOptionStore();

defineProps<{
  menu: {
  	icon: String,
  	title: string,
  	url: String,
  	highlight: Boolean,
	label: string,
	img: string,
  	children: Array<{
      icon: String,
      title: String,
      url: string,
      highlight: Boolean,
      children: Object
    }>
  };
}>();

function subIsActive(urls: Array<{ url: string }>) {
	var currentRoute = useRouter().currentRoute.value.path;
	var match = false;
	
	for (var x = 0; x < urls.length; x++) {
		if (urls[x].url == currentRoute) {
			match = true;
		}
	}
	
	return match;
}
// captura del nombre del elemento del menú seleccionado
const handleMenuClick = (title: string, icon:string, navigate: () => void, event: MouseEvent) => {  
  appOption.appSelectedMenu = title; // Guardado del nombre en la store
  appOption.appSelectedMenuIcon = icon; // Guardado del icono en la store
  event.preventDefault(); // Evitar el comportamiento predeterminado del enlace
  navigate(); // Continuar con la navegación normal
}
</script>
<template>
	<!-- menu with submenu -->
	<div v-if="menu.children" class="menu-item has-sub" v-bind:class="{ 'active': subIsActive(menu.children) }">
		<a class="menu-link">
			<span class="menu-icon" v-if="menu.icon">
				<i v-bind:class="menu.icon"></i>
				<span class="w-5px h-5px rounded-3 bg-theme position-absolute top-0 end-0 mt-3px me-3px" v-if="menu.highlight"></span>
			</span>
			<span class="menu-icon-img" v-if="menu.img">
				<img v-bind:src="menu.img" alt="" />
			</span>
			<span class="menu-text">
				{{ menu.title }}
				<span class="menu-label" v-if="menu.label">{{ menu.label }}</span>
			</span>
			<span class="menu-caret" v-if="menu.children"></span>
		</a>
		<div class="menu-submenu">
			<template v-for="(submenu, index) in menu.children">
				<sidebar-nav v-bind:menu="submenu"></sidebar-nav>
			</template>
		</div>
	</div>
  
	<!-- menu without submenu -->
	<router-link v-else v-bind:to="menu.url" custom v-slot="{ navigate, href, isActive }">
		<div class="menu-item" v-bind:class="{ 'active': isActive }">
			<a v-bind:href="href" @click="handleMenuClick(menu.title, menu.icon, navigate, $event)" class="menu-link">
				<span class="menu-icon" v-if="menu.icon">
					<i v-bind:class="menu.icon"></i>
				</span>
				<span class="menu-icon-img" v-if="menu.img">
					<img v-bind:src="menu.img" alt="" />
				</span>
				<span class="menu-text">
					{{ menu.title }}
					<span class="menu-label" v-if="menu.label">{{ menu.label }}</span>
				</span>
			</a>
		</div>
	</router-link>
</template>